module.exports = __webpack_public_path__ + "static/media/52.f438f467.jpg";